/*
 * @Description:
 * @Date: 2024-01-11 14:07:18
 */

const views = (require as any).context(
  './',
  true,
  /pc-module-process-\d+\.vue/
);

export default views.keys().map(path => {
  return views(path).default;
});

export const getProcessData = () => {
  return [
    '明确调研课题',
    '确定调研样本数量',
    '制定调研数据维度',
    '确定调研对象及调研单位',
    '确定调研方式方法',
    '明确调研数据整理分析方法',
    '制定调研时间周期及进度安排',
    '确定调研预算',
    '确定调研结果展现形式',
    '开展调研',
    '调研数据的整理及分析'
  ];
};
